import { fetchDataFromBackend } from "../api/api";

// Sends in-app feedback to the support inbox. The backend fixes the recipient
// (info@optivasoft.de) and reads the sender's identity from the JWT — the client
// only supplies category, priority and message.
export const FeedbackService = {
  async sendFeedback({ category, priority, message }) {
    return fetchDataFromBackend("/Notification/feedback", {
      skipAuth: false,
      method: "post",
      data: { category, priority, message },
    });
  },
};
